/* eslint-disable no-nested-ternary */
import React from 'react';
import {
  Form, FormGroup, Label,
} from 'reactstrap';
import PropTypes from 'prop-types';

import { FormField } from '../../../../../utils/FormFields';
import { PersonType } from '../../../../Profile/Account/types';

function DocumentsTab({
  person,
  changedPerson,
  showChanges,
  remove,
}) {
  const editDocument = changedPerson.Documents[0];
  let compareDocument;
  person.Documents.forEach((d) => {
    if (parseInt(d.PhysicalPersonDocumentTypeId, 10)
      === parseInt(editDocument.PhysicalPersonDocumentTypeId, 10)) {
      compareDocument = d;
    }
  });
  let color = 'black';
  if (showChanges) {
    if (compareDocument === undefined) {
      color = 'green';
    } else {
      color = remove ? 'red' : '#36a9e1';
    }
  }
  return (
    <Form>
      <Label style={{
        fontWeight: 500, fontSize: '20px', display: 'block', color,
      }}
      >
        {showChanges ? (
          <React.Fragment>
            {compareDocument !== undefined
              ? (remove ? 'Remove Document' : 'Edited Document')
              : 'New Document'}
          </React.Fragment>
        ) : 'Actual Account'}
      </Label>
      {showChanges
        ? (
          <FormGroup tag="fieldset">
            {compareDocument ?
              <FormToShow document={editDocument} compareDoc={compareDocument} person={person}/>
              :
              <FormToShow document={editDocument} person={person}/>
              }
          </FormGroup>
        )
        : (
          <FormGroup tag="fieldset">
            {compareDocument && <FormToShow document={compareDocument} person={person} />}
          </FormGroup>
        )}
    </Form>
  );
}

DocumentsTab.propTypes = {
  person: PropTypes.object.isRequired,
  changedPerson: PropTypes.object,
  showChanges: PropTypes.bool.isRequired,
  remove: PropTypes.bool.isRequired,
};

DocumentsTab.defaultProps = {
  changedPerson: undefined,
};

const FormToShow = ({ document, compareDoc, person}) => (
  <React.Fragment>
    {person.PersonType == PersonType.Physical ?
      <FormField
        label="Person Name: "
        value={person.PhysicalPersonFirstName + ' '+ person.PhysicalPersonFirstLastName}
        name="PersonName"
        changedColor={false}
      /> : 
      <FormField
          label="Person Name: "
          value={person.JuridicalPersonLegalName}
          name="DocumentNumber"
          changedColor={false}
        />}
    <FormField
      label="Document Number: "
      value={document.PhysicalPersonDocumentNumber}
      name="DocumentNumber"
      changedColor={compareDoc
        && document.PhysicalPersonDocumentNumber
        !== compareDoc.PhysicalPersonDocumentNumber}
    />
    <FormField
      label="Type: "
      value={`${document.PhysicalPersonDocumentTypeName}${document.PhysicalPersonDocumentIsMain ? ' (Main)' : ''}`}
      name="Type"
      changedColor={compareDoc
        && document.PhysicalPersonDocumentTypeName !== compareDoc.PhysicalPersonDocumentTypeName}
    />
    <FormField
      label="Expiration Date: "
      value={document.PhysicalPersonDocumentExpirationDate}
      name="Date"
      changedColor={compareDoc
        && document.PhysicalPersonDocumentExpirationDate
        !== compareDoc.PhysicalPersonDocumentExpirationDate}
    />
    <FormField
      label="Country: "
      value={document.PersonDocumentIssueCountryName}
      name="Country"
      changedColor={compareDoc
        && document.PersonDocumentIssueCountryName
        !== compareDoc.PersonDocumentIssueCountryName}
    />
  </React.Fragment>
);

FormToShow.propTypes = {
  document: PropTypes.object.isRequired,
  compareDoc: PropTypes.object,
  person: PropTypes.object.isRequired,
};

FormToShow.defaultProps = {
  compareDoc: undefined,
};

export default (DocumentsTab);